module.exports = __webpack_public_path__ + "static/img/daily-warn-active.a86a737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/daily-warn-active.png
// module id = GR0m
// module chunks = 58